import { render, staticRenderFns } from "./CompleteUnapproved.vue?vue&type=template&id=2f2c3d64&"
import script from "./CompleteUnapproved.vue?vue&type=script&lang=js&"
export * from "./CompleteUnapproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports